// src/auth/utils/tokenInterceptor.ts
import { AxiosInstance } from 'axios';
import AuthApi from '../api/authApi';
import { useAccessTokenStore } from '../store/useAccessTokenStore';

const applyAuthInterceptors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    const token = useAccessTokenStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/auth/refresh')) {
        originalRequest._retry = true;
        try {
          const { accessToken } = await AuthApi.refresh();
          useAccessTokenStore.getState().setToken(accessToken);
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          useAccessTokenStore.getState().clear();
          return Promise.reject(refreshError);
        }
      }
      return Promise.reject(error);
    },
  );
};

export default applyAuthInterceptors;
